var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step"},[_c('question-address',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"address","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"session-data":_vm.form['home'],"subtitle":"What's the address of the house you're insuring?"},on:{"input":_vm.updateStepData}}),_c('question-property-owned',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-owned","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"validation-errors":{
      propertyOwned: {
        is_not: 'Please confirm if you own or rent your home.',
      },
    }},on:{"input":_vm.updateStepData}}),_c('question-property-cover-type',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-cover-type","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"help-text":{
      value: "\n        <p>\n          <b>Buildings and Contents cover</b> – This provides cover for both the buildings and the contents of the property.\n        </p>\n        <p>\n          <b> Buildings Only</b> - This covers the structure of your home including the roof walls, windows, fixtures and fixings.\n        </p>\n        <p>\n          <b>Contents Only</b> - This covers items that belong to people who live in the property. This can include clothes, electronic goods, furniture, carpets and curtains.\n        </p>",
      collapsible: _vm.isExperimentMinimiseHelptext,
      openerText: 'Insurance Cover type',
    }},on:{"input":_vm.updateStepData}}),_c('question-property-sort',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-sort","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"help-text":{
      value: "\n        <p>\n          If you're currently renting a room in the property and share a bathroom, please\n          select <b>‘Other’</b> then <b>‘Bedsit/Halls of Residence’</b>.\n        </p>\n        <p>\n          If you live in a flat/apartment that has more than one storey, please select <b>‘Flat/Apartment’</b> then <b>‘Maisonette’</b>.\n        </p>",
      collapsible: _vm.isExperimentMinimiseHelptext,
      openerText: 'Selecting Property Type',
    }},on:{"input":_vm.updateStepData}}),_c('question-property-type',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-type","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"validation-errors":{
      propertyType: {
        required: 'Please select your property type.',
      },
    }},on:{"input":_vm.updateStepData}}),_c('question-property-floor',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-floor","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"validation-errors":{
      propertyFloor: {
        required: 'Please select your property\'s floor.',
      },
    }},on:{"input":_vm.updateStepData}}),_c('question-base-counter-list',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-rooms","form-observer":_vm.formObserver,"title":"How many rooms does the property have?","help-text":_vm.propertyRoomsHelpText,"session-data":_vm.form['home'],"custom-fields":[
      'propertyBedrooms',
      'propertyBathrooms',
      'propertyLivingrooms',
      'propertyOtherooms' ],"options-config":{
      options: {
        propertyBedrooms: {
          label: 'Bedrooms',
          max: 99,
          min: 1,
        },
        propertyBathrooms: {
          label: 'Bathrooms',
          max: 99,
          min: 1
        },
        propertyLivingrooms: {
          label: 'Living room/lounges',
          max: 99,
        },
        propertyOtherooms: {
          label: 'Other rooms',
          max: 99,
        }
      }
    },"form-data":_vm.form,"step-data":_vm.step},on:{"toast":_vm.showToast,"input":_vm.updateStepData}}),_c('question-property-year',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-year","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step},on:{"input":_vm.updateStepData}}),_c('question-property-roof',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-roof-made","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"validation-errors":{
      propertyRoofMade: {
        is_not: 'Please select the roof material.',
      },
    },"help-text":{
      value: "\n        <p>Please choose the material that the majority of the roof is made from.</p>\n        <p>Slate is a natural stone product. Tiles will generally be made from concrete or clay and come in a variety of profiles, shapes and colours.</p>\n      ",
      collapsible: _vm.isExperimentMinimiseHelptext,
      openerText: 'Selecting Roof Material',
    }},on:{"input":_vm.updateStepData}}),_c('question-property-flat-roof',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-flat-roof","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step},on:{"input":_vm.updateStepData}}),_c('question-property-assumptions',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"property-assumptions","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step},on:{"input":_vm.updateStepData}}),_c('question-build-sums-ins',{tag:"component",attrs:{"product-name":"home","step-id":"home","question-id":"build-sums-ins","title":"How much buildings cover do you need?","form-observer":_vm.formObserver,"form-data":_vm.form,"step-data":_vm.step,"help-text":{
      value: '<p>Note, this is different to the market value of the home – usually a higher value as it includes the land value your home sits on.</p><p class=\'pt-0\'>If unsure, you may wish to obtain professional advice. If your home is found to be underinsured in the event of a claim, your insurer may not settle the full claim.</p>',
      title: 'This is the estimated cost of rebuilding your home. You can usually find this figure in your mortgage valuation documents, surveyors report or previous insurance documents.',
      openerText: 'Show more',
      closerText: 'Hide',
      collapsible: true,
      fullWidth: true
    },"prerequisites":[
      {
        field: 'postcode',
        validationRules: {
          required: true
        },
      },
      {
        field: 'houseNumberOrName',
        validationRules: {
          required: true
        },
      },
      {
        field: 'propertyType',
        validationRules: {
          required: true
        },
      },
      {
        field: 'propertySort',
        validationRules: {
          required: true
        },
      },
      {
        field: 'propertyWallsMade',
        validationRules: {
          required: true
        },
      },
      {
        field: 'propertyYear',
        validationRules: {
          propertyYear: true,
          required: true,
        },
      },
      {
        field: 'propertyCoverType',
        validationRules: {
          is_not: {
            other: 'C',
          },
          required: true,
        },
      },
      {
        field: 'propertyRoofMade',
        validationRules: {
          required: true
        },
      },
      { field: 'propertyBedrooms' },
      { field: 'propertyBathrooms' } ],"custom-fields":{ field: 'buildSumsIns' },"show-rules":{
      propertyCoverType: {
        is_not: {
          other: 'C'
        },
        required: true
      }
    }},on:{"toast":_vm.showToast,"input":_vm.updateStepData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }